import React, { Fragment } from 'react';
import { Flex, Link } from '@tpr/core';
import { ArrowRight } from '@tpr/icons';
export var Breadcrumbs = function (_a) {
    var links = _a.links, send = _a.send;
    var totalLinks = links.length - 1;
    if (links.length < 1)
        return null;
    return (React.createElement(Flex, { cfg: { alignItems: 'center' } }, links.map(function (link, index) {
        return (React.createElement(Fragment, { key: index },
            React.createElement(Link, { onClick: function () { return send(link.to); }, underline: link.underline, disabled: link.disabled }, link.name),
            index !== totalLinks && React.createElement(ArrowRight, { fill: "#036db8" })));
    })));
};
//# sourceMappingURL=breadcrumbs.js.map